import {
	ChangeEvent, FormEvent, Fragment, FunctionComponent, InputHTMLAttributes, MouseEvent, ReactFragment, useEffect, useMemo, useState
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@abm-international/react-components';
import Modal from '../modal/modal';
import Customers from '../../modules/Customers/Customers';
import { ProductSelect } from '../../modules/Comocat/POM/Products';
import './Form.scss';


export type FormInputField = { zoek?: string } & ({
    type: 'p',
    name?: string;
    value?: any,
    label?: string;
    placeholder?: string;
    caption?: string;
    validation?: any;
} | {
    type: 'div',
    name?: string;
    value?: any,
    html?: any,
    label?: string;
    placeholder?: string;
    caption?: string;
    validation?: any;
} | {
    type: 'select',
    name?: string;
    id?: string;
    options?: Record<string, string>;
    value?: any;
    //html?: any,
    //label?: string;
    //placeholder?: string;
    caption?: string;
    validation?: any;
} | {
    type: 'table';
    add?: any;
    name: string;
    id?: string;
    label?: string;
    class?: string;
    columns?: FormInputField[];
    placeholder?: string;
    caption?: string;
    zoek?: string;
    value?: any;
    data?: {[index: string]: any}[];
    validation?: {
        required?: string;
    }
} | {
    type: 'number' | 'text' | 'multi' | 'date' | 'time' | 'tel' | 'multi' | 'hidden';
    add?: any;
    name: string;
    id?: string;
    label?: string;
    class?: string;
    columns?: any;
    placeholder?: string;
    caption?: string;
    zoek?: string;
    value?: any;
    data?: any;
    validation?: {
        required?: string;
    }
})

export type FormField = {
    type: 'group';
    children?: FormField[];
    name?: string;
    value?: undefined;
} | FormInputField;


interface FormProps {
    fields: FormField[];
    onSubmit: (values: { [index: string]: any }) => void;
    onCancel: () => void;
}

export const SearchComponents = {
	default: () => <div>DEFAULT</div>,
	klanten: Customers,
	producten: ProductSelect,
	// producten: ProductsView,
	// producten: ProductsList,
};

export type FormInputProps = InputHTMLAttributes<HTMLFormElement> & FormInputField & {
    onUpdateValue: (value: any, name?: string) => void;
    error?: string;
    label?: any;
};

export const dateRegex = new RegExp(/(?<day>\d{1,2})\/(?<month>\d{1,2})\/(?<year>\d{2,4})|(?<year_1>\d{2,4})-(?<month_1>\d{1,2})-(?<day_1>\d{1,2})/g);

export const FormInput = (props: FormInputProps) => {
	const {
		type, name, id, value, error, label, placeholder, validation, caption, onUpdateValue, zoek
	} = props;
	const [showZoek, setShowZoek] = useState(false);

	const SearchComponent: FunctionComponent | ReactFragment = useMemo(() => {
		return (zoek && zoek in SearchComponents) ? SearchComponents[zoek as keyof typeof SearchComponents] : Fragment;
	}, [zoek]);

	const formattedValue = useMemo(() => {
		if (!value) return value;

		switch (type) {
			case 'number':
				return Number(value);
			case 'date':
				const [_input, day0, month0, year0, year1, month1, day1] = dateRegex.exec(value) || [undefined];
				return `${year0 || year1 }-${month0 || month1 }-${day0 || day1 }`;
			default:
				return value;
		}
	}, [type, value]);

	if (type === 'hidden') return null;

	const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
		onUpdateValue(e.currentTarget.value);
	};

	const handleInputChanged = (e: ChangeEvent<HTMLInputElement>) => {
		onUpdateValue(e.currentTarget.value);
	};

	// aka props
	const proppies = {
		onSelect: (item: any) => {
			setShowZoek(false);
			if ('address' in item) {
				onUpdateValue(item.id, name);
				onUpdateValue(item.name, 'klant-naam');
				onUpdateValue(item.address.street, 'klant-adres');
				onUpdateValue(item.address.city, 'klant-gemeente');
			} else if ('article' in item) {
				onUpdateValue(item.code, 'tbl-artikel-nr');
				onUpdateValue(item.name, 'tbl-artikel-naam');
			} else {
				onUpdateValue('Test', name);
			}
		}
	};

	return (
		<div className='formInput form__field'>
			<Modal
				style={{ minWidth: '80vw', minHeight: '60vh' }}
				show={showZoek}
				close={(e: MouseEvent<HTMLDivElement>) => { e.stopPropagation(); setShowZoek(false); }}
			>
				<SearchComponent {...(zoek ? proppies : {}) as any} />
			</Modal>

			<label htmlFor={id || name}>{caption || label || name}</label>

			<div className='input'>
				<input
					className={`Input${ error ? ' hasError' : ''}`}
					type={type}
					name={name}
					id={id || name}
					value={formattedValue ?? ''}
					onChange={handleInputChange}
					placeholder={placeholder}
					onBlur={handleInputChanged}
				/>

				{!!zoek && <FontAwesomeIcon icon={faSearch} onClick={() => setShowZoek(true)} />}
			</div>

			{error && <span className='formError'>{error}</span>}
		</div>
	);
};

export interface FormFieldsProps {
    fields?: FormField[];
    values: { [index: string]: any };
    errors: { [index: string]: any };
    onUpdateField: (name: string, value: any) => void;
}

export const FormFields = (props: FormFieldsProps) => {
	const {
		fields, values, errors, onUpdateField
	} = props;

	return (
		<>
			{fields?.map((field, index) => {
				if (field.type === 'group') {
					return (
						<div key={index} className="formGroup">
							<FormFields
								fields={field.children}
								errors={errors}
								values={values}
								onUpdateField={onUpdateField}
							/>
						</div>
					);
				}

				if (field.type === 'multi') {
					console.log('multi field', errors[field.name]);
					return <div key={index} className="formInput form__field">
						<label htmlFor={field.name}>{field.label || field.name}</label>
						<div className='input ' >
							<textarea
								style={{ resize: 'vertical' }}
								className={`Input ${errors[field.name] ? 'hasError' : ''}`}
								cols={10}
								rows={5}
								value={values[field.name]}
								id={field.name}
								name={field.name}
								onChange={(e) => onUpdateField(field.name, e.target.value)}
							/>
						</div>
					</div>;
				}

				if (field.type === 'table') {
					return <div key={index}>
						{(values[field.name] as any[]).map((row, indexRow) => {
							return (
								<>
									<div className='table_row'>
										<FormFields
											fields={field.columns}
											values={row}
											errors={{}}
											onUpdateField={(v, e) => {
												const newRow = { ...row };
												newRow[v] = e;
												const data = [...values[field.name] || []];
												const index = data.findIndex(item => field.columns?.[0]?.name && item[field.columns[0].name] === row[field.columns[0].name]);
												if (index > -1) {
													data[index][v] = e;
												}
												onUpdateField(field.name, data);
											}}
										/>

										{(values[field.name].length || 0) > 1 && <span className='table_row_remove'>
											<Button
												onClick={() => {
													const newData = [...values[field.name]];
													const index = newData.findIndex(item => field.columns?.[0]?.name && item[field.columns[0].name] === row[field.columns[0].name]);
													if (index > -1) {
														newData.splice(index, 1);
													}
													onUpdateField(field.name, newData);
												}}
											>
												<FontAwesomeIcon icon={faTrash} />
											</Button>
										</span>}
									</div>

									{indexRow === (values[field.name].length || 0) -1 && <span>
										<div className='form__field'>
											<Button
												disabled={(values[field.name] as any[]).reduce<boolean>((acc, value) => {
													const rowHasEmpty = Object.values<any>(value).reduce((a, e) => a || e === undefined || e === '', false);
													const hoeveelEmpty = (value['tbl-artikel-hoeveel'] === undefined || value['tbl-artikel-hoeveel'] === '') && (value['tbl-artikel-aantal'] === undefined || value['tbl-artikel-aantal'] === '');
													return acc || rowHasEmpty || hoeveelEmpty;
												}, false)}
												onClick={() => {
													const newRow: any = {};
													field.columns?.forEach(column => {
														if (!column.name) return;
														newRow[column.name] = '';
													});
													const newData = [
														...values[field.name] || [],
														newRow,
													];
													onUpdateField(field.name, newData);
												}}
											>
												<FontAwesomeIcon icon={faPlus} />
											    &nbsp; Add new row
											</Button>
										</div>
									</span>}
								</>
							);
						})}
					</div>;
				}

				if (field.type === 'select') {
					const optionsObj = field.options || {};
					return (
						<div key={index} className="formInput form__field">
							<label htmlFor={field.name}>{field.caption}</label>
							<select name={field.name} id={field.name} form="carform" onChange={(e) => field?.name && onUpdateField(field?.name, e.target.value)} value={field?.name && values[field.name]}>
								{Object.entries(optionsObj).map(([value, label], idx) => (
									<option key={idx} value={value}>{String(label)}</option>
								))}
							</select>
						</div>
					);
				}

				if (
					field.type === 'number' ||
                    field.type === 'text' ||
                    field.type === 'hidden'||
                    field.type === 'date' ||
                    field.type === 'time' ||
                    field.type === 'tel'
				) {
					return (
						<FormInput
							{...field}
							value={values[field.name]}
							error={errors[field.name]}
							onUpdateValue={(v, name) => onUpdateField(name || field.name, v)}
						/>
					);
				}

				if (field.type === 'p') {
					return <p className='form__field'>{field.caption}</p>;
				}

				if (field.type === 'div') {
					return <div className='form__field' dangerouslySetInnerHTML={{ __html: field.html }} />;
				}

				return null;
			})}
		</>
	);
};

export const Form = (props: FormProps) => {
	const { fields, onSubmit, onCancel } = props;

	const [formValues, setFormValues] = useState<{ [index: string]: any }>(() => {
		const values: { [index: string]: any } = {};
		fields.forEach(field => {
			if (!field.name) return;
			if (field.type === 'table') {
				values[field.name] = field.data;
			} else if (field.type === 'select') {
				if (field.value !== undefined) {
					values[field.name] = field.value;
				} else if (field.options && Object.keys(field.options).length > 0) {
					values[field.name] = Object.keys(field.options)[0];
				} else {
					values[field.name] = '';
				}
			} else {
				values[field.name] = field.value;
			}
		});
		return values;
	});
	const [formErrors, setFormErrors] = useState<{ [index: string]: any }>({});

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

	 let valid = true;
		const newErrors: { [index: string]: any } = {};

		fields.forEach(field => {
			if (!field.name) return;
			if (
				field.type !== 'group' &&
            field.type !== 'p' &&
            field.validation?.required &&
            (!formValues[field.name] && formValues[field.name] !== 0)
			) {
				newErrors[field.name] = 'Veld moet ingevuld zijn';
				valid = false;
			}
		});

		setFormErrors(newErrors);

		if (!valid) {
			return false;
		}

		// TODO: validate form inputs before send
		onSubmit?.(formValues);
		return false;
	};

	const handleCancel = () => {
		onCancel?.();
	};

	const onUpdateField = (name: string, value: any) => {
		setFormErrors(previous => {
			const errors = { ...previous };
			errors[name] = undefined;
			return errors;
		});

		setFormValues(previous => {
			const values = { ...previous };
			values[name] = value;
			return values;
		});

		const field = fields.find(f => f.type !== 'group' && f.type !== 'p' && f.name === name);
		if (!field || !('validation' in field)) return;
		if (field?.validation) {
			if (field.validation.required && (!value && value !== 0)) {
				setFormErrors(p => {
					const errors = { ...p };
					errors[name] = 'Field is required';
					return errors;
				});
			}
		}
	};

	return (
		<form className='Form DynamicForm' onSubmit={handleSubmit}>
			<FormFields
				fields={fields}
				values={formValues}
				errors={formErrors}
				onUpdateField={onUpdateField} />

			<div className="form__field submit">
				<input type='button' value='Cancel' className='cancel' onClick={handleCancel} />
				<input type='submit' value='Send' />
			</div>
		</form>
	);
};
